<template>
  <div id="app" class="editor_viewer">
    <ckeditor
      :editor="editor"
      v-model="editorData"
      :disabled="editorDisabled"
      :readonly="editorDisabled"
    ></ckeditor>
  </div>
</template>

<script>
import ClassicEditor from '../plugins/ckeditor5';

export default {
  name: 'Editor',
  data() {
    return {
      editor: ClassicEditor,
      editorDisabled: true
    };
  },
  props: ['content'],
  computed: {
    editorData() {
      return this.content;
    }
  },
  created() {}
};
</script>
<style>
#app{
  margin-top: 20px;
}
.ck-editor__editable {
  min-height: 200px;
  /* max-height: 500px; */
}
.ck-editor__editable.ck-read-only {
  /* border-top:0; */
  background:transparent;
  max-height: unset;
  /* border-radius: 10px !important; */
}

.editor_viewer .ck-toolbar {
  border: 0 !important;
}
.editor_viewer figure {
  outline: none !important;
}
.editor_viewer .ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,
.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected {
  outline: none !important;
}

.mainPop .ck-editor__editable {
  width: 430px;
  height: 640px;
}
.mainPop #app {
  margin:0;
}
.mainPop .ck-content .image {
  margin:0;
  width:100%;
  height:100%;
}
.mainPop .ck-content .image img {
  height:100%;
}
.mainPop.mobilePop .ck-editor__editable {
  width: 320px;
  height: 440px;
}
.mainPop .ck-content .image img {
  height:100%;
}
.mainPop .ck.ck-editor__editable_inline {
  padding:0;
}
</style>
